export const navigationConfig = [
    {
        label: 'О сервисе',
        path: '/',
        roles: [],
        component: () => import('@/pages/MainPage'),
        name: 'Home'
    },
    {
        label: 'Поиск НЧЗ',
        path: '/lowfrequency',
        roles: [],
        component: () => import('../pages/catalog/LowFrequency.vue'),
        name: 'LowFrequency'
    },
    // {
    //     label: 'Готовые НЧЗ',
    //     path: null, // Для действий без маршрута
    //     name: 'nchz',
    //     roles: [],
    //     action: () => { /* Открытие диалога будет в компоненте */ }
    // },
    {
        label: 'Аналитика',
        path: '/analytics',
        roles: [],
        component: () => import('../pages/Analytics.vue'),
        name: 'Analytics'
    },
    {
        label: 'Пользователи',
        path: '/users',
        roles: ['admin'],
        component: () => import('../pages/Users.vue'),
        name: 'Users'
    },
    {
        label: 'Партнёрка',
        path: '/partner',
        roles: ['admin', 'partner'],
        component: () => import('../pages/PartnerProfile.vue'),
        name: 'Partner'
    },
    {
        label: 'Админка', // Для мобильного меню или логики выхода
        path: '/admin',
        roles: ['admin'], // Доступно всем
        component: () => import('../pages/Admin.vue'),
        name: 'Admin'
    },
    {
        label: 'Токены',
        path: '/tokens',
        roles: [],
        component: () => import('../pages/TokensPurchase.vue'),
        name: 'TokensPurchase',
        visible: false
    },
    {
        label: 'Выход', // Для мобильного меню или логики выхода
        path: '/login',
        roles: [], // Доступно всем
        component: () => import('../pages/LoginPage.vue'),
        name: 'Login',
        visible: false
    },
    {
        label: 'Регистрация', // Для мобильного меню или логики выхода
        path: '/register',
        roles: [], // Доступно всем
        component: () => import('../pages/LoginPage.vue'),
        name: 'Registration',
        visible: false
    }
]